import type { MailboxInfo } from "owa-client-types";
import isBusiness from "./isBusiness";
import isPremiumConsumer from "../selectors/isPremiumConsumer";

export default function isPaid(mailboxInfo: MailboxInfo): boolean {
    return isBusiness(mailboxInfo) || isPremiumConsumer(mailboxInfo);
}
